// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1698135515700
      var cssReload = require("/Users/admin/workspace/ss/ss-web-game/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  